import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export let isStartingSoon = (sessionTime: string): boolean => {
  let start = dayjs.utc(sessionTime)
  let now = dayjs.utc()
  return start.isAfter(now) && start.diff(now, 'minute', true) <= 10
}

// True when now is within the join window: T−10 min through effective end (endTime ?? T+2h)
export let isJoinWindowOpen = (
  sessionTime: string,
  endTime?: string,
): boolean => {
  let now = dayjs.utc()
  let windowOpen = dayjs.utc(sessionTime).subtract(10, 'minute')
  let effectiveEnd = endTime
    ? dayjs.utc(endTime)
    : dayjs.utc(sessionTime).add(2, 'hour')
  return !windowOpen.isAfter(now) && !now.isAfter(effectiveEnd)
}

// True when the session's effective end time has already passed.
// effectiveEnd = endTime if provided, else sessionTime + 2 hours.
export let isSessionPast = (sessionTime: string, endTime?: string): boolean => {
  let effectiveEnd = endTime
    ? dayjs.utc(endTime)
    : dayjs.utc(sessionTime).add(2, 'hour')
  return dayjs.utc().isAfter(effectiveEnd)
}
